<div class="fixed inset-x-0 bottom-0 px-4 pb-6 sm:inset-0 sm:flex sm:items-center sm:justify-center sm:p-0">
  <div class="fixed inset-0 transition-opacity">
    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
  </div>
  <div
    class="transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 shadow-xl transition-all sm:w-full sm:max-w-sm sm:p-6">
    <div>
      <div class="bg-orange-200 mx-auto flex h-12 w-12 items-center justify-center rounded-full">
        <!-- <svg class="h-6 w-6 text-green-600" stroke="currentColor" fill="none" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
        </svg> -->
        <svg
          class="text-orange-700 h-6 w-6"
          fill="none"
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          viewBox="0 0 24 24">
          <path
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <div class="mt-3 text-center sm:mt-5">
        <h3 class="text-xl font-medium leading-6 text-gray-900">Manutenzione in corso</h3>
        <div class="mt-2">
          <p class="leading-5 text-gray-500">Siamo spiacenti. Riprova tra poco.</p>
          <p class="mt-2">
            <span *ngIf="loading" class="loader"></span>
            <button *ngIf="!loading" type="button" class="btn btn-primary btn-sm" (click)="reload()">Aggiorna</button>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
